import { Field, FormikProps, useFormikContext } from 'formik'
import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B3_FORM_INITIAL_VALUES } from '../constants'
import RadioInput from '../../../../../../../../components/inputs/RadioInput'

interface Props {}

export const B37EnergyConservation: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<typeof B3_FORM_INITIAL_VALUES>
  return (
    <FormSectionTwoColumns
      sectionKey="b3.energyConservation"
      title="B.3.7 Úspora energie a tepelná ochrana budovy"
    >
      <div className="sm:col-span-6 mt-5">
        <Field
          name="b3.energyConservation.option"
          component={RadioInput}
          options={[
            {
              label: 'Není projektem řešeno',
              value: 'none',
            },
            {
              label: 'Viz. průkaz energetické náročnosti budovy',
              value: 'energyEfficiencyCertificate',
            },
            {
              label: 'Vlastní',
              value: 'other',
            },
          ]}
        />
        {formik.values.b3.energyConservation.option === 'other' && (
          <div className="pl-7">
            <div className="sm:col-span-6 mt-3">
              <Field
                name="b3.energyConservation.description"
                label=""
                component={RichTextInput}
                aiHint="Úspora energie a tepelná ochrana budovy"
              />
            </div>
          </div>
        )}
      </div>
    </FormSectionTwoColumns>
  )
}
